import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { capitalize } from "@mui/material";
import { SendPostRequest } from "../../../http";
import Spinner from "../../Spinner";
import HeaderWrapper from "../../Header/HeaderWrapper";
import FooterWrapper from "../../Footer/FooterWrapper";
import { limitParagraphByCharLimit } from "../../../Helper/Helper";
import TextMainBannerWrapper from "../../TextMainBanners/TextMainBannerWrapper";

function ServicesListing() {
  const sitedata = useSelector((store) => store.global.loginData);
  const [isLoading, setIsLoading] = useState(true);
  const [isData, setIsdata] = useState(false);
  const [servicesData, setServicesData] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
    getServicesData();
  }, []);

  const getServicesData = async () => {
    const response = await SendPostRequest("services/list");
    setIsLoading(false);

    if (!response?.data || response?.data?.length < 1) {
      setIsdata(true);
    } else {
      setServicesData(response.data);
    }
  };

  return (
    <div className="page-wrapper-inner">
      <div className="page-wrapper-inner">
        <HeaderWrapper />

        <TextMainBannerWrapper
          Heading={sitedata?.site_type === "hospitals" ? "Our Specialties" : "Services"}
          Image="theme-2-banner-speciality.webp"
        />


        <div className="container">
          {sitedata?.site_type === "hospitals" ? (
            <div className="row mt-5">
              <div className="offset-md-2 col-md-8">
                <div className="title-wrap text-center">
                  <div className="section-title margin-bottom-60">
                    <h2 className="section-title mb-0 text-uppercase">
                      Provides Our{" "}
                      <span className="theme-color">Best Specialties</span>
                    </h2>
                    <span className="section-border-bottom center"></span>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="mt-5"></div>
          )}

          <div className="row my-3">
            {isLoading ? (
              <div className="col-12 text-center">
                <Spinner />
              </div>
            ) : isData ? (
              <div className="col-12 text-center mb-4">
                <h4>No Record Available</h4>
              </div>
            ) : (
              servicesData.map((service, index) => (
                <div className="col-lg-4 item" key={index}>
                  <div className="service-box-wrap service-box-style-2 mb-5">
                    <div className="service-box-inner">
                      <div className="service-thumb">
                        <Link
                          to={`/${sitedata?.site_type === "hospitals" ? "speciality" : "service"}/${service?.uid}/${service?.service_title
                            .replaceAll(" ", "-")
                            .replaceAll("/", "-")}`}
                          rel="noopener noreferrer"
                        >
                          <img
                            className="img-fluid squared w-100 third-fservices-image"
                            src={service?.service_image_url}
                            alt={service?.service_title}
                          />
                        </Link>
                      </div>
                      <div className="service-main-content">
                        <h3 className="mb-0 service-title">
                        <Link
                          to={`/${sitedata?.site_type === "hospitals" ? "speciality" : "service"}/${service?.uid}/${service?.service_title
                            .replaceAll(" ", "-")
                            .replaceAll("/", "-")}`}
                          rel="noopener noreferrer"
                        >
                            {service?.service_title}
                        </Link>
                          </h3>
                        <div className="service-link">
                          <Link
                            to={`/${sitedata?.site_type === "hospitals" ? "speciality" : "service"}/${service?.uid}/${service?.service_title
                              .replaceAll(" ", "-")
                              .replaceAll("/", "-")}`}
                            rel="noopener noreferrer"
                            className="link"
                          >
                            <i className="ti-arrow-top-right"></i>
                          </Link>
                        </div>
                      </div>
                      <div className="service-overlay-content">
                        <div className="service-meta">
                          <h3 className="mb-2 service-title">
                            <a href={service?.link} className="">
                              {service?.service_title}
                            </a>
                          </h3>
                          <div className="service-link">
                            <Link
                              to={`/${sitedata?.site_type === "hospitals" ? "speciality" : "service"}/${service?.uid}/${service?.service_title
                                .replaceAll(" ", "-")
                                .replaceAll("/", "-")}`}
                              rel="noopener noreferrer"
                              className="link"
                            >
                              <i className="ti-arrow-top-right"></i>
                            </Link>
                          </div>
                        </div>
                        {/* <div
                          className="service-desc mb-4"
                          dangerouslySetInnerHTML={{
                            __html:
                              limitParagraphByCharLimit(service?.service_short_description, 70) +
                              (service?.service_short_description?.length > 70 ? "..." : ""),
                          }}
                        /> */}
                      </div>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
        <FooterWrapper />
      </div>
    </div>
  );
}

export default ServicesListing;
